import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import classes from "./MultiFieldV2.scss";
import classNames from "classnames";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import LabelComponent from "Projects/components/StepContainer/components/LabelComponent";
import FieldComponent from "../FieldComponent";
import update from "immutability-helper";
import EmptyField from "UIComponents/EmptyField";
import { BentArrowTopLeftOutlined } from "@toddle-edu/ds-icons";

const customStyles = {
  containerStyle: { marginTop: 0, gridGap: 0 },
};

class MultiFieldV2 extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.fieldRefs = {};
  }

  updateInputFieldLocally = ({ params }) => {
    let updatedValue = {};
    const { value } = this.props;

    _.forEach(params, (paramValue, key) => {
      updatedValue = update(value, {
        [key]: {
          $set: paramValue,
        },
      });
    });

    this.updateValue(updatedValue);
  };

  onFocusInputField = ({ key }) => {
    const { onFocusInputField } = this.props;
    onFocusInputField?.({ others: { id: key } });
  };

  onBlurInputField = ({ key }) => {
    const { onBlurInputField } = this.props;
    onBlurInputField?.({ others: { id: key } });
  };

  blur = () => {
    _.map(this.fieldRefs, ref => {
      if (ref) {
        ref.blur();
      }
    });
  };

  setFieldRef = (key, ref) => {
    this.fieldRefs[key] = ref;
  };

  renderEditEmpty = () => {
    const { emptyText, emptyContainerStyle, emptyStateComponent } = this.props;

    if (emptyStateComponent) {
      return emptyStateComponent;
    }

    return (
      !!emptyText && (
        <EmptyField containerStyle={emptyContainerStyle} title={emptyText} />
      )
    );
  };

  renderEdit = () => {
    const {
      subFields,
      subFieldAlignment = "horizontal",
      value,
      mode,
      fieldLockedObject,
      helpEnabledFields,
      onHelpClick,
      getIsHelpActive,
      disabled = false,
      isListView,
      filterEmptyValues,
      styles,
      subFieldStyles,
      dsVersion,
      isHeightAdaptive,
    } = this.props;

    const containerClass = classNames(
      { [classes.container]: true },
      { [classes.rowContainer]: subFieldAlignment == "vertical" }
    );

    const { lockedDynamicFields } = fieldLockedObject;
    const isViewMode = mode === "view";

    return (
      <div className={containerClass} style={{ gap: "24px" }}>
        {_.map(subFields, field => {
          const { key, config, type, viewType } = field;
          const lockedField = _.find(lockedDynamicFields, { id: key });
          const { label, subtext } = config;
          const subFieldValue = (value || {})[key];

          // skip component rendering if the value is empty and filterEmptyValues is true
          if (filterEmptyValues && _.isEmpty(subFieldValue) && isViewMode)
            return null;

          const helper = _.find(helpEnabledFields, eachField => {
            return _.get(eachField, "uid", "") === key;
          });

          const helperTextId = _.get(helper, "helpText.id", "");

          const labelComponent = (
            <LabelComponent
              {...config}
              label={label}
              showHelper={!_.isEmpty(helper)}
              isHelpActive={getIsHelpActive({ fielduid: key })}
              onHelpClick={() =>
                onHelpClick({
                  fieldKey: key,
                  helperTextId: helperTextId,
                  id: key,
                })
              }
              isFieldHeader={true}
            />
          );

          const fieldComponent = (
            <FieldComponent
              {...config}
              value={subFieldValue}
              key={key}
              labelComponent={labelComponent}
              subText={subtext}
              customRef={this.setFieldRef}
              onFocusInputField={this.onFocusInputField}
              onBlurInputField={this.onBlurInputField}
              type={!isViewMode ? type : viewType}
              fieldKey={key}
              fieldLockedObject={{ lockedField }}
              updateInputField={this.updateInputFieldLocally}
              containerStyle={customStyles.containerStyle}
              mode={mode}
              styles={subFieldStyles || styles}
              disabled={disabled}
              labelContainerStyle={{ marginBottom: 0 }}
              dsVersion={dsVersion}
              isHeightAdaptive={isHeightAdaptive}
            />
          );

          if (isListView && isViewMode) {
            return (
              <div key={key} className={classes.listViewContainer}>
                <div className={classes.listViewIcon}>
                  <BentArrowTopLeftOutlined size="x-small" variant="subtle" />
                </div>
                {fieldComponent}
              </div>
            );
          }

          return fieldComponent;
        })}
      </div>
    );
  };

  shouldShowViewEmpty = () => {
    return false;
  };

  shouldShowEditEmpty = () => {
    const { subFields } = this.props;
    return _.isEmpty(subFields);
  };

  renderView = () => {
    return this.renderEdit();
  };
}

MultiFieldV2.defaultProps = {
  ...UIBaseComponent.defaultProps,
  containerStyle: {},
  isHelpActive: _.noop,
  getIsHelpActive: _.noop,
};

MultiFieldV2.propTypes = {
  ...UIBaseComponent.propTypes,
  isHelpActive: PropTypes.func,
  getIsHelpActive: PropTypes.func,
};

export default MultiFieldV2;
